import { SettlementDetailsConfig } from '@app/shared/types/pages/settlementDetails';
import { Page } from '@app/routes';

export const SETTLEMENT_DETAILS_CONFIG: SettlementDetailsConfig = {
  //Land
  0: {
    multiplier: 0.5,
    items: {
      panda: {
        className: 'size-[240px] left-[46%]',
        top: '570',
        actionType: 'video',
        mediaId: 203,
      },
      wheel: {
        className: 'size-[320px] left-[17%]',
        top: '-100',
        actionType: 'wheel',
      },
      blanket: {
        className: 'size-[180px] left-[32%]',
        top: '-120',
        actionType: 'audio',
        mediaId: 1,
      },
      telescope: {
        className: 'size-[250px] -left-[2%]',
        top: '-190',
        actionType: 'redirect',
        route: Page.DAILY_ENERGY,
      },
    },
  },
  //Camping
  1: {
    multiplier: 0.6,
    items: {
      cup: {
        className: 'size-[170px] left-[58%]',
        top: '450',
        actionType: 'audio',
        mediaId: 2,
      },
      pillow: {
        className: 'size-[180px] left-[10%]',
        top: '335',
        actionType: 'video',
        mediaId: 202,
      },
      radio: {
        className: 'size-[200px] left-[47%]',
        actionType: 'audio',
        top: '295',
        mediaId: 39,
      },
    },
  },
  //Hut
  2: {
    multiplier: 0.55,
    items: {
      pillow: {
        className: 'size-[185px] top-[45%] left-[66%]',
        top: '380',
        actionType: 'audio',
        mediaId: 7,
      },
      radio: {
        className: 'size-[190px] left-[52%]',
        top: '425',
        actionType: 'audio',
        mediaId: 56,
      },
      cards: {
        className: 'size-[130px] left-[40%]',
        top: '58',
        actionType: 'redirect',
        route: Page.DAILY_CARD_DESCRIPTION,
      },
    },
  },
  //Cottage
  3: {
    multiplier: 0.7,
    items: {
      pillow: {
        className: 'size-[200px] left-[6%]',
        top: '600',
        actionType: 'audio',
        mediaId: 9,
      },
      radio: {
        className: 'size-[160px] left-[54%]',
        top: '430',
        actionType: 'audio',
        mediaId: 42,
      },
      cards: {
        className: 'size-[130px] left-[24%]',
        top: '172',
        actionType: 'redirect',
        route: Page.DAILY_CARD_DESCRIPTION,
      },
    },
  },
  //Coworking
  4: {
    multiplier: 0.55,
    items: {
      pillow: {
        className: 'size-[160px] left-[20%]',
        top: '490',
        actionType: 'audio',
        mediaId: 10,
      },
      carpet: {
        className: 'size-[260px] left-[38%]',
        top: '470',
        actionType: 'video',
        mediaId: 200,
      },
      radio: {
        className: 'size-[220px] left-[56%]',
        top: '-20',
        actionType: 'audio',
        mediaId: 43,
      },
    },
  },
  //Cafe
  6: {
    multiplier: 0.6,
    items: {
      speaker: {
        className: 'size-[260px] left-[2%]',
        top: '600',
        actionType: 'audio',
        mediaId: 44,
      },
      pillow: {
        className: 'size-[170px] left-[52%]',
        top: '400',
        actionType: 'audio',
        mediaId: 12,
      },
      notebook: {
        className: 'size-[220px] left-[28%]',
        top: '15',
        actionType: 'audio',
        mediaId: 57,
      },
    },
  },
  //Farm
  7: {
    multiplier: 0.5,
    items: {
      pillow: {
        className: 'size-[190px] left-[12%]',
        top: '565',
        actionType: 'audio',
        mediaId: 13,
      },
      player: {
        className: 'size-[240px] left-[50%]',
        top: '285',
        actionType: 'audio',
        mediaId: 45,
      },
      candles: {
        className: 'size-[140px] left-[40%]',
        top: '-170',
        actionType: 'audio',
        mediaId: 8,
      },
    },
  },
  //Spa
  8: {
    multiplier: 0.55,
    items: {
      blanket11: {
        className: 'size-[220px] left-[50%]',
        top: '600',
        actionType: 'audio',
        mediaId: 15,
      },
      cup11: {
        className: 'size-[150px] left-[26%]',
        top: '153',
        actionType: 'audio',
        mediaId: 46,
      },
      massage11: {
        className: 'size-[320px] left-[5%]',
        top: '82',
        actionType: 'audio',
        mediaId: 17,
      },
    },
  },
  //Temple
  9: {
    multiplier: 0.65,
    items: {
      piano: {
        className: 'size-[270px] left-[2%]',
        top: '500',
        actionType: 'audio',
        mediaId: 47,
      },
      pillow: {
        className: 'size-[210px] left-[52%]',
        top: '265',
        actionType: 'audio',
        mediaId: 20,
      },
    },
  },
  //Fitness
  10: {
    multiplier: 0.65,
    items: {
      carpet: {
        className: 'size-[220px] left-[2%]',
        top: '500',
        actionType: 'audio',
        mediaId: 19,
      },
      gong: {
        className: 'size-[240px] left-[52%]',
        top: '245',
        actionType: 'audio',
        mediaId: 48,
      },
      pillow: {
        className: 'size-[160px] left-[24%]',
        top: '165',
        actionType: 'video',
        mediaId: 201,
      },
    },
  },
  // House of art
  11: {
    multiplier: 0.65,
    items: {
      picture: {
        className: 'size-[200px] left-[40%]',
        top: '500',
        actionType: 'audio',
        mediaId: 54,
      },
      player: {
        className: 'size-[240px] left-[38%]',
        top: '405',
        actionType: 'audio',
        mediaId: 49,
      },
      stand: {
        className: 'size-[200px] left-[34%]',
        top: '-185',
        actionType: 'audio',
        mediaId: 55,
      },
    },
  },
  // Academy
  12: {
    multiplier: 0.65,
    items: {
      book: {
        className: 'w-[160px] left-[32%]',
        top: '400',
        actionType: 'audio',
        mediaId: 53,
      },
      table: {
        className: 'size-[160px] left-[46%]',
        top: '55',
        actionType: 'soon',
      },
      speaker: {
        className: 'w-[180px] left-[35%]',
        top: '-45',
        actionType: 'audio',
        mediaId: 50,
      },
    },
  },
  // Bank
  13: {
    multiplier: 0.55,
    items: {
      cards: {
        className: 'size-[110px] left-[75%]',
        top: '460',
        actionType: 'soon',
      },
      pillow: {
        className: 'size-[100px] left-[72%]',
        top: '280',
        actionType: 'audio',
        mediaId: 31,
      },
      speaker: {
        className: 'size-[130px] left-[32%]',
        top: '105',
        actionType: 'audio',
        mediaId: 51,
      },
    },
  },
  // Business center
  // Небоскреб DOM
  // Остров в Pandora
};
